// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images//info.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images//show-toyota.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/images//show-lexus.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/images//hide-toyota.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/images//hide-lexus.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/images//edit.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/images//warning.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../assets/images//Artboard 4.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../assets/images//delete.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../assets/images//active-flag.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../assets/images//inactive-flag.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../assets/images//Artboard 3down.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../../assets/images//Artboard 3up.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../../assets/images//rocket.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.activityContainer {
    font-size: 0.81rem;
    font-family: "Arial", sans-serif;
    max-width: none !important;
    margin-bottom: 3rem;
}

.activityTableContainer .tab-content {
    border-bottom-right-radius: 1.25rem;
    border-bottom-left-radius: 1.25rem;
    border-top-right-radius: 1.25rem;
    background-color: #f0f0f0;
    padding: 1.25rem;
    /* height: 33rem;
    width: 81.5rem; */
}

.activityTableContainer .activity-content {
    border-bottom-right-radius: 1.25rem;
    border-bottom-left-radius: 1.25rem;
    border-top-right-radius: 1.25rem;
    border-top-left-radius: 1.25rem;
    background-color: #f0f0f0;
    /* width: 81.5rem; */
}

.info-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    height: 19px;
    width: 19px;
    background-position: center;
    margin: 0 0.3rem;
}

.toyota-show-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    height: 19px;
    width: 19px;
    background-position: center;
    margin: 0 0.3rem;
}

.lexus-show-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    height: 19px;
    width: 19px;
    background-position: center;
    margin: 0 0.3rem;
}

.toyota-hide-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    height: 19px;
    width: 19px;
    background-position: center;
    margin: 0 0.3rem;
}

.lexus-hide-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    height: 19px;
    width: 19px;
    background-position: center;
    margin: 0 0.3rem;
}

.edit-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
    height: 19px;
    width: 18px;
    background-position: center;
    margin: 0 0.3rem;
}
.critical-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
    height: 19px;
    width: 18px;
    background-position: center;
    margin: 0 0.3rem;
    pointer-events: visible;
}

.add-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
    height: 25px;
    width: 26px;
    background-position: center;
    margin: 0 0.3rem;
    float: right;
    margin-left: 0.75rem !important;
    margin-top: -0.31rem !important;
}

.view-icon {
    /* background-image: url("../../assets/images/view.png"); */
    height: 19px;
    width: 30px;
    background-position: center;
    background-repeat: no-repeat;
    margin: 0 0.3rem;
    float: right;
}

.launch-icon {
    /* background-image: url("../../assets/images/launch.png"); */
    height: 19px;
    width: 30px;
    background-position: center;
    background-repeat: no-repeat;
    margin: 0 0.3rem;
    float: right;
}

.delete-icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
    height: 19px;
    width: 18px;
    background-position: center;
    margin: 0 0.3rem;
}

.noPadding {
    padding: 0px !important;
    margin: 0px !important;
}

.lexus-FontWithBold {
    color: #252525;
    font-weight: bold;
    padding-left: 1rem !important;
    padding-top: 1.0rem;
    margin-top: 0.2rem;
}

.toyota-FontWithBold {
    color: #e50000;
    font-weight: bold;
    padding-left: 1rem !important;
    padding-top: 1.0rem;
    margin-top: 0.2rem;
}

.searchActivityTable {
    padding: 1rem;
    min-height: 300px !important;
}

/* Table header stick  */

/* .searchActivityTable thead, .searchActivityTable tbody, .searchActivityTable tr, .searchActivityTable td, .searchActivityTable th { display: block; }
.searchActivityTable .react-bootstrap-table{
    height: 25rem !important;
}
.searchActivityTable tr:after {
    content: ' ';
    display: block;
    visibility: hidden;
    clear: both;
}

.searchActivityTable tbody {
    height: 21.8rem;
    overflow-y: auto;
}

.searchActivityTable tbody > tr > td { 
    width: 7.5rem; 
    float: left;
} 
.searchActivityTable thead > tr > th { 
    width: 7.5rem;
    float: left;
}  */

/* .searchActivityTable thead > tr > th:first-child { 
    width: 5rem !important;
    float: left;
}
.searchActivityTable tbody > tr > td:first-child  { 
    width: 5rem;
    float: left;
} */

/* Table stick header end  */

/* .searchActivityTable .react-bootstrap-table{
    padding:1rem;
}

.searchActivityTable tbody tr {
    border: 1px solid grey !important;
    border-radius: 5px;
} */

.searchActivityTable .active-flag {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
    height: 18px;
    width: 18px;
    background-position: center;
    margin: 0 0.3rem;
    margin-left: 2.03rem;
}

.searchActivityTable .inactive-flag {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
    height: 18px;
    width: 18px;
    background-position: center;
    margin: 0 0.3rem;
    margin-left: 2.03rem;
}

.boldFont {
    font-weight: bold;
    padding-top: 1.0rem;
}

.activity-content input {
    border-radius: 0.25rem !important;
}

tbody tr {
    border-bottom: 5px solid #f0f0f0!important;
}

.deleteConfirmBox {
    padding: 1rem;
    background-color: #FFFFFF;
    border-radius: 20px;
    width: 30rem;
    font-family: "Arial", sans-serif;
    font-size: 0.81rem;
}

.deleteConfirmBox .modal-footer {
    padding: 0px;
}

.parent-toyota #pageDropDown {
    background-color: #E50000 !important;
}

.parent-lexus #pageDropDown {
    background-color: #252525 !important;
}

.pagination {
    float: right;
}

.parent-toyota .pagination .active>a {
    background-color: #E50000 !important;
}

.parent-lexus .pagination .active>a {
    background-color: #252525 !important;
}

.react-bootstrap-table-pagination-list {
    padding-top: 0px;
}

span.order span.dropdown {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
    width: 16px;
    height: 20px;
    float: left;
    background-position: center;
    position: absolute;
    background-size: 80px 60px;
    visibility: hidden;
}

span.order span.dropup {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
    width: 16px;
    height: 20px;
    float: left;
    position: absolute;
    background-position: center;
    background-size: 80px 60px;
    visibility: hidden;
}

.activityTable tbody, .activityTable tr {
    display: block;
}

.activityTable tr:after {
    content: ' ';
    display: block;
    visibility: hidden;
    clear: both;
}

.activityTable tbody {
    height: 74vh;
    overflow-y: scroll;
}

.activityTable table {
    border-spacing: 3px 7px;
    border-collapse: separate;
    margin-bottom: 0px !important;
}

.activityTable tbody>tr>td {
    width: 7rem;
    float: left;
    text-overflow: ellipsis;
    overflow: hidden;
}

.activityTable thead>tr>th {
    width: 7rem;
    float: left;
}

.rocket {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
}

.hideSortIcon {
    visibility: hidden 
}

.showSortIcon {
    visibility: visible !important
}

div.activityTable div.row.react-bootstrap-table-pagination div {
    padding: 0px !important;
}

.scoreLabel {
    z-index: 10;
    position: absolute;
    top: 0;
    left: 0;
    margin-left: 41%;
    color:white;
}
.scoreProgressBar .progress {
    top: 0;	
    left: 0;
}

.searchActivityTable .dropdown-menu > li > a  { 
    display: block;
    /* padding: 3px 20px;
    clear: both;
    font-weight: 400;
    line-height: 1.42857143;
    color: #333;
    white-space: nowrap; */
}

.padding-top {
padding-top: 10px !important;
}

.success-act {
    color:#28A745;
}
.danger-act {
    color:#d81d1d;
}
.default-act {
    color:#808080;
}
.yellow-act {
    color:#FBA803;
}
.blank-act {
    color:#FFFFFF;
}
.progressb {
    background-color: #808080 !important;
}
.progressp {
    background-color: #6CB4EE !important;
}
.circleSize{
    font-size:32px !important;
}
.actionPlanbtn{
    line-height: 1.5;
    color: white;
    text-align: center;
    font-size: 0.675rem,
}
`, "",{"version":3,"sources":["webpack://./src/components/activity/index.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,mCAAmC;IACnC,kCAAkC;IAClC,gCAAgC;IAChC,yBAAyB;IACzB,gBAAgB;IAChB;qBACiB;AACrB;;AAEA;IACI,mCAAmC;IACnC,kCAAkC;IAClC,gCAAgC;IAChC,+BAA+B;IAC/B,yBAAyB;IACzB,oBAAoB;AACxB;;AAEA;IACI,yDAAsD;IACtD,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,yDAA6D;IAC7D,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,yDAA4D;IAC5D,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,yDAA6D;IAC7D,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,yDAA4D;IAC5D,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,yDAAsD;IACtD,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;AACpB;AACA;IACI,yDAAyD;IACzD,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,yDAA4D;IAC5D,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;IAChB,YAAY;IACZ,+BAA+B;IAC/B,+BAA+B;AACnC;;AAEA;IACI,2DAA2D;IAC3D,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,4BAA4B;IAC5B,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,6DAA6D;IAC7D,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,4BAA4B;IAC5B,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,yDAAwD;IACxD,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,6BAA6B;IAC7B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,6BAA6B;IAC7B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,4BAA4B;AAChC;;AAEA,wBAAwB;;AAExB;;;;;;;;;;;;;;;;;;;;;;;IAuBI;;AAEJ;;;;;;;GAOG;;AAEH,4BAA4B;;AAE5B;;;;;;;GAOG;;AAEH;IACI,yDAA6D;IAC7D,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,0DAA+D;IAC/D,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,0DAAgE;IAChE,WAAW;IACX,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,kBAAkB;IAClB,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,0DAA8D;IAC9D,WAAW;IACX,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,2BAA2B;IAC3B,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,WAAW;IACX,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,0DAAwD;AAC5D;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,MAAM;IACN,OAAO;AACX;;AAEA;IACI,cAAc;IACd;;;;;0BAKsB;AAC1B;;AAEA;AACA,4BAA4B;AAC5B;;AAEA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB;AACJ","sourcesContent":[".activityContainer {\n    font-size: 0.81rem;\n    font-family: \"Arial\", sans-serif;\n    max-width: none !important;\n    margin-bottom: 3rem;\n}\n\n.activityTableContainer .tab-content {\n    border-bottom-right-radius: 1.25rem;\n    border-bottom-left-radius: 1.25rem;\n    border-top-right-radius: 1.25rem;\n    background-color: #f0f0f0;\n    padding: 1.25rem;\n    /* height: 33rem;\n    width: 81.5rem; */\n}\n\n.activityTableContainer .activity-content {\n    border-bottom-right-radius: 1.25rem;\n    border-bottom-left-radius: 1.25rem;\n    border-top-right-radius: 1.25rem;\n    border-top-left-radius: 1.25rem;\n    background-color: #f0f0f0;\n    /* width: 81.5rem; */\n}\n\n.info-icon {\n    background-image: url(\"../../assets/images//info.png\");\n    height: 19px;\n    width: 19px;\n    background-position: center;\n    margin: 0 0.3rem;\n}\n\n.toyota-show-icon {\n    background-image: url(\"../../assets/images//show-toyota.png\");\n    height: 19px;\n    width: 19px;\n    background-position: center;\n    margin: 0 0.3rem;\n}\n\n.lexus-show-icon {\n    background-image: url(\"../../assets/images//show-lexus.png\");\n    height: 19px;\n    width: 19px;\n    background-position: center;\n    margin: 0 0.3rem;\n}\n\n.toyota-hide-icon {\n    background-image: url(\"../../assets/images//hide-toyota.png\");\n    height: 19px;\n    width: 19px;\n    background-position: center;\n    margin: 0 0.3rem;\n}\n\n.lexus-hide-icon {\n    background-image: url(\"../../assets/images//hide-lexus.png\");\n    height: 19px;\n    width: 19px;\n    background-position: center;\n    margin: 0 0.3rem;\n}\n\n.edit-icon {\n    background-image: url(\"../../assets/images//edit.png\");\n    height: 19px;\n    width: 18px;\n    background-position: center;\n    margin: 0 0.3rem;\n}\n.critical-icon {\n    background-image: url(\"../../assets/images//warning.png\");\n    height: 19px;\n    width: 18px;\n    background-position: center;\n    margin: 0 0.3rem;\n    pointer-events: visible;\n}\n\n.add-icon {\n    background-image: url(\"../../assets/images//Artboard 4.png\");\n    height: 25px;\n    width: 26px;\n    background-position: center;\n    margin: 0 0.3rem;\n    float: right;\n    margin-left: 0.75rem !important;\n    margin-top: -0.31rem !important;\n}\n\n.view-icon {\n    /* background-image: url(\"../../assets/images/view.png\"); */\n    height: 19px;\n    width: 30px;\n    background-position: center;\n    background-repeat: no-repeat;\n    margin: 0 0.3rem;\n    float: right;\n}\n\n.launch-icon {\n    /* background-image: url(\"../../assets/images/launch.png\"); */\n    height: 19px;\n    width: 30px;\n    background-position: center;\n    background-repeat: no-repeat;\n    margin: 0 0.3rem;\n    float: right;\n}\n\n.delete-icon {\n    background-image: url(\"../../assets/images//delete.png\");\n    height: 19px;\n    width: 18px;\n    background-position: center;\n    margin: 0 0.3rem;\n}\n\n.noPadding {\n    padding: 0px !important;\n    margin: 0px !important;\n}\n\n.lexus-FontWithBold {\n    color: #252525;\n    font-weight: bold;\n    padding-left: 1rem !important;\n    padding-top: 1.0rem;\n    margin-top: 0.2rem;\n}\n\n.toyota-FontWithBold {\n    color: #e50000;\n    font-weight: bold;\n    padding-left: 1rem !important;\n    padding-top: 1.0rem;\n    margin-top: 0.2rem;\n}\n\n.searchActivityTable {\n    padding: 1rem;\n    min-height: 300px !important;\n}\n\n/* Table header stick  */\n\n/* .searchActivityTable thead, .searchActivityTable tbody, .searchActivityTable tr, .searchActivityTable td, .searchActivityTable th { display: block; }\n.searchActivityTable .react-bootstrap-table{\n    height: 25rem !important;\n}\n.searchActivityTable tr:after {\n    content: ' ';\n    display: block;\n    visibility: hidden;\n    clear: both;\n}\n\n.searchActivityTable tbody {\n    height: 21.8rem;\n    overflow-y: auto;\n}\n\n.searchActivityTable tbody > tr > td { \n    width: 7.5rem; \n    float: left;\n} \n.searchActivityTable thead > tr > th { \n    width: 7.5rem;\n    float: left;\n}  */\n\n/* .searchActivityTable thead > tr > th:first-child { \n    width: 5rem !important;\n    float: left;\n}\n.searchActivityTable tbody > tr > td:first-child  { \n    width: 5rem;\n    float: left;\n} */\n\n/* Table stick header end  */\n\n/* .searchActivityTable .react-bootstrap-table{\n    padding:1rem;\n}\n\n.searchActivityTable tbody tr {\n    border: 1px solid grey !important;\n    border-radius: 5px;\n} */\n\n.searchActivityTable .active-flag {\n    background-image: url(\"../../assets/images//active-flag.png\");\n    height: 18px;\n    width: 18px;\n    background-position: center;\n    margin: 0 0.3rem;\n    margin-left: 2.03rem;\n}\n\n.searchActivityTable .inactive-flag {\n    background-image: url(\"../../assets/images//inactive-flag.png\");\n    height: 18px;\n    width: 18px;\n    background-position: center;\n    margin: 0 0.3rem;\n    margin-left: 2.03rem;\n}\n\n.boldFont {\n    font-weight: bold;\n    padding-top: 1.0rem;\n}\n\n.activity-content input {\n    border-radius: 0.25rem !important;\n}\n\ntbody tr {\n    border-bottom: 5px solid #f0f0f0!important;\n}\n\n.deleteConfirmBox {\n    padding: 1rem;\n    background-color: #FFFFFF;\n    border-radius: 20px;\n    width: 30rem;\n    font-family: \"Arial\", sans-serif;\n    font-size: 0.81rem;\n}\n\n.deleteConfirmBox .modal-footer {\n    padding: 0px;\n}\n\n.parent-toyota #pageDropDown {\n    background-color: #E50000 !important;\n}\n\n.parent-lexus #pageDropDown {\n    background-color: #252525 !important;\n}\n\n.pagination {\n    float: right;\n}\n\n.parent-toyota .pagination .active>a {\n    background-color: #E50000 !important;\n}\n\n.parent-lexus .pagination .active>a {\n    background-color: #252525 !important;\n}\n\n.react-bootstrap-table-pagination-list {\n    padding-top: 0px;\n}\n\nspan.order span.dropdown {\n    background-image: url(\"../../assets/images//Artboard 3down.png\");\n    width: 16px;\n    height: 20px;\n    float: left;\n    background-position: center;\n    position: absolute;\n    background-size: 80px 60px;\n    visibility: hidden;\n}\n\nspan.order span.dropup {\n    background-image: url(\"../../assets/images//Artboard 3up.png\");\n    width: 16px;\n    height: 20px;\n    float: left;\n    position: absolute;\n    background-position: center;\n    background-size: 80px 60px;\n    visibility: hidden;\n}\n\n.activityTable tbody, .activityTable tr {\n    display: block;\n}\n\n.activityTable tr:after {\n    content: ' ';\n    display: block;\n    visibility: hidden;\n    clear: both;\n}\n\n.activityTable tbody {\n    height: 74vh;\n    overflow-y: scroll;\n}\n\n.activityTable table {\n    border-spacing: 3px 7px;\n    border-collapse: separate;\n    margin-bottom: 0px !important;\n}\n\n.activityTable tbody>tr>td {\n    width: 7rem;\n    float: left;\n    text-overflow: ellipsis;\n    overflow: hidden;\n}\n\n.activityTable thead>tr>th {\n    width: 7rem;\n    float: left;\n}\n\n.rocket {\n    background-image: url(\"../../assets/images//rocket.png\");\n}\n\n.hideSortIcon {\n    visibility: hidden \n}\n\n.showSortIcon {\n    visibility: visible !important\n}\n\ndiv.activityTable div.row.react-bootstrap-table-pagination div {\n    padding: 0px !important;\n}\n\n.scoreLabel {\n    z-index: 10;\n    position: absolute;\n    top: 0;\n    left: 0;\n    margin-left: 41%;\n    color:white;\n}\n.scoreProgressBar .progress {\n    top: 0;\t\n    left: 0;\n}\n\n.searchActivityTable .dropdown-menu > li > a  { \n    display: block;\n    /* padding: 3px 20px;\n    clear: both;\n    font-weight: 400;\n    line-height: 1.42857143;\n    color: #333;\n    white-space: nowrap; */\n}\n\n.padding-top {\npadding-top: 10px !important;\n}\n\n.success-act {\n    color:#28A745;\n}\n.danger-act {\n    color:#d81d1d;\n}\n.default-act {\n    color:#808080;\n}\n.yellow-act {\n    color:#FBA803;\n}\n.blank-act {\n    color:#FFFFFF;\n}\n.progressb {\n    background-color: #808080 !important;\n}\n.progressp {\n    background-color: #6CB4EE !important;\n}\n.circleSize{\n    font-size:32px !important;\n}\n.actionPlanbtn{\n    line-height: 1.5;\n    color: white;\n    text-align: center;\n    font-size: 0.675rem,\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
